<template>
  <v-text-field
    v-model="text"
    type='text'
    :label="label"
    :error-messages="errors"
    :hide-details="!v.$error"
    outlined
    dense
    :disabled="disabled"
  >
  </v-text-field>
</template>

<script>
export default {
  props: [
    'value',
    'v',
    'errors',
    'label',
    'disabled',
  ],

  computed: {
    text: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/forms/InputComponent.vue